import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";

import type { BlockHash, } from "@bracket/types";
import type { ResolverResult, } from "@types";
import type { Notification } from "@bracket/ui";

export const dispatchUnwrappedNotification = ( result: ResolverResult, token: string, amount: string): Omit<Notification, "id"> | null => {
	if(result.success) {
		return unwrappedSuccessNotification(result.hash, token, amount);
	}
	if(result.rejected) {
		return null;
	}
	return unwrappedFailedNotification(result.error);
}


export const unwrappedSuccessNotification = (
	hash: BlockHash,
	token: string,
	amount: string,
): Omit<Notification, "id"> => {
	return {
		title: "Unwrap successful",
		message: `You successfully unwrapped ${amount} ${token}`,
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const unwrappedFailedNotification = (error: Error): Omit<Notification, "id"> => {

  const msg = error.message.toLowerCase();
	const message = (
		"please try again"
	);

	console.warn("unwrapping failed", error.message);

	return {
		title: "Unwrapping failure",
		message: `Unwrapping failed, ${message}`,
		type: "error",
		status: "error",
	}

}
